import { Button } from '@/components/Button';
import { CalibrateLoading } from '@/components/CalibrateLoading/CalibrateLoading';
import { CalibrationCompleted } from '@/components/CalibrationCompleted/CalibrationCompleted';
import { CalibrationFailed } from '@/components/CalibrationFailed/CalibrationFailed';
import { SensorPlacement, SensorPlacementProps } from '@/components/SensorPlacement/SensorPlacement';

import styles from './SensorCalibration.module.css';

interface SensorCalibrationProps {
  placementSensorStates: SensorPlacementProps;
  isLoading: boolean;
  isReady: boolean;
  hasCalibrationFailed: boolean;
  isCalibrationCompleted: boolean;
  startCalibration: VoidFunction;
  resetCalibration: VoidFunction;
}

export const SensorCalibration = ({
  placementSensorStates,
  isLoading,
  isReady,
  hasCalibrationFailed,
  isCalibrationCompleted,
  startCalibration,
  resetCalibration,
}: SensorCalibrationProps) => {
  return (
    <div className={styles.sensorPlacementContainer}>
      {isLoading && (
        <div className={styles.centerContainer}>
          <CalibrateLoading />
        </div>
      )}

      {isReady && !hasCalibrationFailed && (
        <>
          <SensorPlacement
            centerPelvis={'hidden'}
            isBlurred={true}
            leftCalf={'hidden'}
            leftFoot={'not_calibrated'}
            leftPelvis={'hidden'}
            leftThigh={'hidden'}
            rightCalf={'hidden'}
            rightFoot={'not_calibrated'}
            rightPelvis={'hidden'}
            rightThigh={'hidden'}
          />
          <Button className={styles.calibrateButton} onClick={startCalibration}>
            Calibrate
          </Button>
        </>
      )}

      {hasCalibrationFailed && (
        <div className={styles.centerContainer}>
          <>
            <SensorPlacement {...placementSensorStates} />
            <Button className={styles.calibrateButton} leadingIcon='reset' onClick={resetCalibration}>
              Re-calibrate
            </Button>
          </>
          <CalibrationFailed description='Movement detected, please re-calibrate' title='Calibration failed' />
        </div>
      )}

      {isCalibrationCompleted && (
        <div className={styles.centerContainer}>
          <CalibrationCompleted description='Continue to start recording' title='Calibration completed' />
        </div>
      )}
    </div>
  );
};
